import React, { useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
  TableFooter,
  TablePagination,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowSuccessMessage,
} from "../../../common/actions/CommonActions";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../../vacancyApplication/VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";
import { Redirect } from "react-router-dom";
import { UsersRepository } from "../../administration/users/UsersRepository";
import { useEffect } from "react";

export default function VacancyAllotmentComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [vacancyApps, setVacancyApps] = React.useState();
  const [totalAppsRemaining, setTotalAppsRemaining] = React.useState(0);
  const [redirect, setRedirect] = React.useState();
  const [vacancies, setVacancies] = useState();
  const [selectedVacancy, setSelectedVacancy] = useState("");
  const [allotmentDialogOpen, setAllotmentDialogOpen] = useState(false);
  const [commisions, setCommisions] = useState();
  const [selectedCommissions, setSelectedCommissions] = useState([]);

  const [allotments, setAllotments] = useState([]);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    dispatch(
      changePageTitle(`${LOCALE.distribution_applications_by_commission}`)
    );
  }, [dispatch]);

  React.useEffect(() => {
    VacancyAppRepository.getAllForAllotment({
      vacancyId: selectedVacancy,
    }).then((res) => {
      setTotalAppsRemaining(res.data.length);
      setVacancyApps(res.data);
      console.log(res.data);
    });
    fetchAllCommisions();
  }, [selectedVacancy]);

  const openVacancy = (vacId, appId) => {
    setRedirect("/app/vacancy-preview/" + vacId + "/" + appId);
  };

  React.useEffect(() => {
    VacancyRepository.fetchAllVacancy({
      page: 0,
      size: 100,
      orderBy: "dateCreated",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancies(res.data.content);
    });
  }, []);

  const fetchAllCommisions = () => {
    UsersRepository.allCommisionUsers().then((res) => {
      setCommisions(res.data);
    });
  };

  const startAllotment = () => {
    setLoading(true);
    VacancyAppRepository.beginAllotment(allotments).then(
      (res) => {
        setLoading(false);
        setAllotmentDialogOpen(false);
        setSelectedCommissions([]);
        setSelectedVacancy("");
        dispatch(
          notifyShowSuccessMessage("Апликациите се успешно распределени!")
        );
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  React.useEffect(() => {
    console.log(selectedCommissions);
    if (selectedCommissions && selectedCommissions.length > 0) {
      let firstCommission = selectedCommissions[0];
      let lastCommission = selectedCommissions[selectedCommissions.length - 1];
      let tmpAllotments = [];
      vacancyApps.forEach((app) => {
        // put the app one by one for each commission
        let allotment = {
          commissionId: firstCommission,
          vacancyAppId: app.id,
        };
        tmpAllotments.push(allotment);
        // if the last commission is reached, start from the first one
        if (firstCommission === lastCommission) {
          firstCommission = selectedCommissions[0];
        } else {
          // if not, go to the next one
          firstCommission =
            selectedCommissions[
              selectedCommissions.indexOf(firstCommission) + 1
            ];
        }
      });
      console.log(tmpAllotments);
      setAllotments(tmpAllotments);
    }
  }, [selectedCommissions]);

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel id="demo-simple-select-label1">
              {LOCALE.choose_vacancy}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label1"
              id="demo-simple-select1"
              label={LOCALE.choose_vacancy}
              value={selectedVacancy}
              onChange={(e) => setSelectedVacancy(e.target.value)}
            >
              <MenuItem key={221312} value={""}>
                {LOCALE.all}
              </MenuItem>
              {vacancies?.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br></br> <br></br>
      <Card>
        <CardHeader color="theme">
          <Typography>{LOCALE.view_applications_for_distribution}</Typography>

          <Button
            style={{ float: "right", marginLeft: "10px", marginTop: "-5px" }}
            color="primary"
            size="small"
            variant="contained"
            disabled={totalAppsRemaining === 0}
            onClick={() => setAllotmentDialogOpen(true)}
          >
            {LOCALE.start_distribution}
          </Button>
          <Typography style={{ float: "right" }}>
            {LOCALE.total}: {totalAppsRemaining}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell></TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.school}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.teaching_languages}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.created_at}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.status}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "100px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vacancyApps && vacancyApps.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_apps_for_evaluating}
                  </TableCell>
                </TableRow>
              )}
              {vacancyApps &&
                vacancyApps?.map((vacancyApp, index) => (
                  <TableRow
                    key={index}
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{vacancyApp.basicInfo.school.name}</TableCell>
                    <TableCell>
                      {LOCALE.getString(vacancyApp.basicInfo.teachingLanguage)}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.dateCreated &&
                        moment(vacancyApp.dateCreated).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.submissionDate &&
                        moment(vacancyApp.submissionDate).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.status &&
                        vacancyApp.status === "SUBMITTED" && (
                          <Chip
                            label={LOCALE.getString("SUBMITTED")}
                            style={{
                              color: "white",
                              backgroundColor: "orange",
                            }}
                          />
                        )}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() =>
                          openVacancy(vacancyApp.vacancy.id, vacancyApp.id)
                        }
                      >
                        <Icon size={10}>edit</Icon> &nbsp;
                        {LOCALE.open}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      <Dialog
        open={allotmentDialogOpen}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">
          Распределба на апликации
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Изберете комисии од листата за да започнете со распределба на
            апликациите. Апликациите ќе се распределат еднакво на сите избрани
            комисии.
          </DialogContentText>
          <Grid container spacing={3}>
            <Grid item md={12}>
              <FormControl
                variant="outlined"
                size="small"
                className={classes.formControl}
                style={{ width: "100%" }}
              >
                <InputLabel id="demo-simple-select-label2">
                  {"Избери комисии"}
                </InputLabel>
                <Select
                  label="Избери комисии"
                  size="small"
                  value={selectedCommissions}
                  multiple
                  onChange={(e) => setSelectedCommissions(e.target.value)}
                >
                  {commisions &&
                    commisions.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            {selectedCommissions &&
              selectedCommissions.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <Typography>
                    {`${commisions.find((x) => x.id === item).name} - ${
                      allotments &&
                      allotments.filter((x) => x.commissionId === item).length
                    } апликации`}
                  </Typography>
                  <Typography></Typography>
                </Grid>
              ))}
          </Grid>
          <br></br>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setAllotmentDialogOpen(false)}
            color="secondary"
            disabled={loading}
          >
            Откажи
          </Button>
          <Button
            onClick={() => startAllotment()}
            color="primary"
            disabled={!allotments || allotments.length == 0 || loading}
            loading={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Започни распределба"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
